import updateCart from './update-popup-cart.js';
import updatedPromosList from './update-promo-list';
import { applyPromoFromBanner } from './helpers';
import { postData, deleteData } from './fetch';

window.addEventListener('load', () => {
  const applyPromoWithProductsBtn = document.querySelectorAll(
    '.apply-promo-with-products',
  );
  const cancelPromoBtn = document.querySelectorAll('.cancel-promo');

  if (applyPromoWithProductsBtn) {
    [].forEach.call(applyPromoWithProductsBtn, (btn) => {
      btn.addEventListener('click', async () => {
        const { number } = btn.dataset;

        const parentElement = btn.closest('.sale-popup');

        if (parentElement) {
          const checkedProducts = parentElement.querySelectorAll(
            '.input-button:checked',
          );

          const ids = [];

          if (checkedProducts) {
            [].forEach.call(checkedProducts, (product) => {
              const productIndex = ids.findIndex(item => item.id === product.value);

              if (productIndex === -1) {
                ids.push({ id: product.value, quantity: 1 });
              } else {
                ids[productIndex].quantity += 1;
              }
            });

            btn.textContent = 'Загрузка...';
            btn.classList.add('disabled');

            const body = {
              products: JSON.stringify(ids),
            };

            const response = await postData('/cart?menuType=delivery', body);

            if (response) {
              if (response.statusCode === 200) {
                ids.forEach((item) => {
                  const productBuyWrapper = document.querySelector(
                    `.buy-wrapper[data-id="${item.id}"]`,
                  );

                  if (productBuyWrapper) {
                    const buyBtn = productBuyWrapper.querySelector(
                      '.buy-button',
                    );
                    const countBtn = productBuyWrapper.querySelector(
                      '.count-button',
                    );

                    if (buyBtn) {
                      buyBtn.classList.add('hidden');
                    }

                    if (countBtn) {
                      const countInput = countBtn.querySelector(
                        '.count-input',
                      );

                      if (countBtn.classList.contains('visible')) {
                        countInput.value =
                          parseInt(countInput.value, 10) + 1;
                      } else {
                        countBtn.classList.add('visible');
                      }
                    }
                  }
                });

                updateCart(response.data, response.data.additional);

                const promoBody = {
                  promo: number,
                  hidden: true,
                };

                applyPromoFromBanner(promoBody, btn);
              }
            }
          }
        }
      });
    });
  }

  if (cancelPromoBtn) {
    [].forEach.call(cancelPromoBtn, (btn) => {
      btn.addEventListener('click', async () => {
        const code = btn.dataset.number;

        btn.setAttribute('disabled', 'disabled');
        btn.textContent = 'Загрузка...';

        const parentElement = btn.closest('.sale-popup');

        const response = await deleteData(`/cart/promo/${code}?menuType=delivery`, null);

        if (response) {
          btn.classList.remove('visible');
          btn.removeAttribute('disabled');
          btn.textContent = 'Отменить акцию';

          if (parentElement) {
            const applyPromoBtn = parentElement.querySelector(
              '.apply-promo',
            );
            const applyPromoBtnWithProducts = parentElement.querySelector(
              '.apply-promo-with-products',
            );
            const errorIcon = parentElement.querySelector(
              '.promo-failed',
            );
            const successIcon = parentElement.querySelector(
              '.promo-success',
            );
            const successTitle = parentElement.querySelector(
              '.success-title',
            );
            const errorTitle = parentElement.querySelector(
              '.error-title',
            );
            const errorText = parentElement.querySelector('.error-text');
            const title = parentElement.querySelector('.sale-title');
            const productsWrapper = parentElement.querySelector(
              '.products-wrapper',
            );

            if (productsWrapper) {
              productsWrapper.classList.remove('hidden');
            }

            if (applyPromoBtnWithProducts) {
              applyPromoBtnWithProducts.classList.remove('hidden');
            }

            if (applyPromoBtn) {
              applyPromoBtn.classList.remove('hidden');
            }

            if (successIcon) {
              successIcon.classList.remove('visible');
            }

            if (successTitle) {
              successTitle.classList.remove('visible');
            }

            if (errorIcon) {
              errorIcon.classList.remove('visible');
            }

            if (errorTitle) {
              errorTitle.classList.remove('visible');
            }

            if (errorText) {
              errorText.textContent = '';
            }

            if (title) {
              title.classList.remove('with-response');
            }
          }

          updateCart(response.data, response.data.additional);
          updatedPromosList(response.data.promos);
        }
      });
    });
  }
});
